import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { useShop } from "@/context/Shop";
import { errMsg } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";

export default function AccountRegister() {
  const { register, customer } = useShop();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "", marketing_email_opt_in: false });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  useSeo("Create your account");
  if (customer) { navigate("/account", { replace: true }); return null; }
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Welcome — your account is ready");
      navigate("/account");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="container-lux py-16 lg:py-24" data-testid="account-register-page">
      <div className="max-w-md mx-auto">
        <h1 className="font-display text-5xl font-medium text-center">Create your account</h1>
        <p className="text-sm text-muted-foreground text-center mt-3">Keep track of orders, wishlists and addresses.</p>
        <form onSubmit={submit} className="mt-10 space-y-5 bg-white border rounded-lg p-6 lg:p-8" data-testid="account-register-form">
          <div className="grid grid-cols-2 gap-4">
            <div><Label htmlFor="r-fn">First name</Label><Input id="r-fn" required value={form.first_name} onChange={upd("first_name")} data-testid="register-firstname-input" /></div>
            <div><Label htmlFor="r-ln">Last name</Label><Input id="r-ln" required value={form.last_name} onChange={upd("last_name")} data-testid="register-lastname-input" /></div>
          </div>
          <div><Label htmlFor="r-email">Email address</Label><Input id="r-email" type="email" required value={form.email} onChange={upd("email")} data-testid="register-email-input" /></div>
          <div><Label htmlFor="r-pass">Password</Label><Input id="r-pass" type="password" required value={form.password} onChange={upd("password")} data-testid="register-password-input" /><p className="text-xs text-muted-foreground mt-1.5">Minimum 10 characters with letters and numbers.</p></div>
          <label className="flex items-start gap-3 text-sm cursor-pointer" data-testid="register-marketing-row"><Checkbox checked={form.marketing_email_opt_in} onCheckedChange={(v) => setForm({ ...form, marketing_email_opt_in: v })} data-testid="register-marketing-checkbox" /><span className="text-foreground/80 leading-relaxed">Keep me informed about new designers, collections and private previews. You can unsubscribe at any time.</span></label>
          <p className="text-xs text-muted-foreground">By creating an account you agree to our <Link to="/pages/terms" className="link-lux text-foreground">terms</Link> and <Link to="/pages/privacy" className="link-lux text-foreground">privacy policy</Link>.</p>
          <button type="submit" disabled={busy} className="btn-ink w-full" data-testid="register-submit-button">{busy ? "Creating…" : "Create account"}</button>
        </form>
        <p className="text-sm text-center mt-8">Already have an account? <Link to="/account/login" className="link-lux text-foreground font-semibold" data-testid="register-signin-link">Sign in</Link></p>
      </div>
    </div>
  );
}
